import select2 from 'select2';

export default function initializeShopsSearch() {
    initializeShopsSelect();
}

function initializeShopsSelect() {
    let select = $('#shops-select').select2({
        language: 'pl',
        minimumResultsForSearch: Infinity
    });

    select.on('select2:select', function (e) {
        if (e.params.data.id !== 'all') {
            window.location.href = e.params.data.element.dataset.link;
        }
    });
}